<template>
  <div class="myInvoiceBox">
    <div>
      <div class="orderSearchBox">
        <el-input v-model="orderNo" placeholder="订单编号"></el-input>
        <el-select v-model="orderStatusValue" clearable placeholder="订单状态">
          <el-option label="已开票" value="PASS"> </el-option>
          <el-option label="开票中" value="EXAMINE"> </el-option>
        </el-select>
        <el-date-picker
            clearable
          v-model="createDateValue"
          type="date"
          placeholder="申请时间"
        >
        </el-date-picker>
        <el-button class="searchBtn" @click="searchInfo">搜索</el-button>
        <el-button type="text" class="resetBtn" @click="clearMessage">
          <i class="iconfont icon-qingchushujuku"></i>
          <span>清除条件</span>
        </el-button>
      </div>
        <div class="orderListTable">
            <ul class="tableHeader">
                <li class="titleImg">模型名称</li>
                <li class="invoiceTime">申请时间</li>
                <li class="invoiceMes">发票抬头</li>
                <li class="invoiceClass">发票类型</li>
                <li class="invoiceCon">发票介质</li>
                <li class="invoiceMoney">发票金额</li>
                <li class="status">状态</li>
                <li class="operation">操作</li>
            </ul>
            <ul class="tableBody">
                <li
                    class="bodyItem"
                    v-for="(printItems, index) in printMessage"
                    :key="index"
                >
                    <div class="itemTop">
                        <div>创建时间：{{ printItems.orderBase.createDate }}</div>
                        <div :data-clipboard-text="printItems.orderBase.orderNo" class="copy-number">
                            订单编号：{{ printItems.orderBase.orderNo }}
                            <i
                                class="el-icon-document-copy numberCopy"
                                @click="numberCopy"
                            ></i>
                        </div>
                    </div>
                    <div class="itemBottom">
                        <div class="titleImg">
                            <div class="orderInfo" v-if="nativeName=='print'">
                                <img :src="printItems.imgs" alt="" />
                                <div class="infoContent">
                                    {{ printItems.title }}
                                </div>
                            </div>
                            <div class="orderInfo" v-if="nativeName=='service'">
                                <img :src="printItems.serviceImg" alt="" />
                                <div class="infoContent">
                                    {{ printItems.serviceName }}
                                </div>
                            </div>
                        </div>
                        <div class="invoiceTime" v-if="nativeName=='print'">
                            {{ printItems.receiptDate }}
                        </div>
                        <div class="invoiceTime" v-else>
                            {{ printItems.createDate }}
                        </div>
                        <div class="invoiceMes">
                            {{ printItems.invoiceTitle }}
                        </div>
                        <div class="invoiceClass" v-if="nativeName=='print'">
                            {{ printItems.invoiceType=='NORMAL'?'普通发票':'专用发票' }}
                        </div>
                        <div class="invoiceClass" v-else>
                            {{ printItems.invoiceTitleType=='NORMAL'?'普通发票':'专用发票' }}
                        </div>
                        <div class="invoiceCon" v-if="nativeName=='print'">
                            {{ printItems.activeName=='ZZFP'?'纸质发票':'电子发票' }}
                        </div>
                        <div class="invoiceCon" v-else>
                            {{ printItems.invoiceType=='ZZFP'?'纸质发票':'电子发票' }}
                        </div>
                        <div class="invoiceMoney">￥{{ printItems.orderBase.totalPrice }}</div>
                        <div class="status">
                            <div class="statusName">{{ printItems.invoiceStatus=='EXAMINE'?'审核中':printItems.invoiceStatus=='PASS'?'已通过':'已拒绝' }}</div>
                        </div>
                        <div class="operation" v-if="nativeName=='print'">
                            <div class="statusName" @click="toDetail(printItems,'print')" >查看详情</div>
                        </div>
                        <div class="operation" v-if="nativeName=='service'">
                            <div class="statusName" @click="toDetail(printItems,'service')" >查看详情</div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
  </div>
</template>

<script>
import { getPrintReceiptOrderList,getServiceOrderList,
    getPrintReceiptInfo,getAddressDetail,findInvoiceInfo } from '../../utils/interface';
import Clipboard from 'clipboard';
export default {
  name: "myInvoice",
  data() {
    return {
        nativeName: "",
      tabList: [
        // {
        //   id: "store",
        //   name: "打印",
        // },
        {
          id: "print",
          name: "打印订单",
        },
        {
          id: "service",
          name: "服务订单",
        },
        {
          id: "design",
          name: "设计订单",
        },
        {
          id: "model",
          name: "模型订单",
        },
        {
          id: "shop",
          name: "商品订单",
        },
      ],
      createDateValue: null,
      orderNumber: "",
      orderNo: "",
      orderStatusValue: "",
      //   分页
      current: 1,
      total: 0,
      pageSize: 8,
      printMessage: [],
        //
        dialogVisible:false,
        addressInfo:"",
        invoiceInfo:"",
        activeName:"",
        receiptStatus:"",
        remark:"",
        receiptUrl:"",
        invoiceUuid:"",
        payeeUuid:"",
    };
  },
    created(){
        this.searchOrderList();
    },
  methods: {
      searchInfo(){
        this.current = 1;
        this.searchOrderList();
      },
      searchOrderList(){
          this.printMessage = [];
          let params = {
              orderNo:this.orderNo,
              isBuy:true,
              invoiceStatus:this.orderStatusValue,
              receiptData:this.createDateValue==null?null : this.createDateValue.getFullYear() +'-'+ (this.createDateValue.getMonth() + 1) +'-'+this.createDateValue.getDate(),
              current:this.current,
              pageSize:this.pageSize,
          };
          if(this.nativeName == "print"){
              getPrintReceiptOrderList(params).then((res)=>{
                  this.total = res.total;
                  this.printMessage = res.data;
              });
          }else if(this.nativeName == "service"){
              params.service = "1";
              getServiceOrderList(params).then((res) => {
                  this.printMessage = res.list;
                  this.total = res.total;
              });
          }
      },
    // 分页
    handleCurrentChange(val) {
      this.current = val;
    },
    // 清除条件
    clearMessage() {
      this.orderNumber = "";
      this.orderNo = "";
      this.orderStatusValue = "";
      this.createDateValue = "";
    },
    // 复制
    numberCopy() {
      // let _this = this;
      let clipboard = new Clipboard(".copy-number"); // 这里括号里填写上面点击事件绑定的class名
      clipboard.on("success", (e) => {
        // 复制成功，提示根据自己项目实际使用的UI来写
        this.$message.success("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制，提示根据自己项目实际使用的UI来写
        this.$message.error("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
      toDetail(item,itemName){
          // 查询按钮详情
          if(itemName==="print"){
              getPrintReceiptInfo({orderPrintUuid:item.printOrderUuid}).then((res)=>{
                  this.activeName = res.data.invoiceStatus;
                  this.receiptStatus = res.data.invoiceStatus;
                  this.receiptUrl = res.data.invoiceUrl;
                  this.remark = res.data.remark;
                  this.invoiceUuid = res.data.invoiceUuid;
                  this.payeeUuid = res.data.payeeUuid;
                  this.getInvoiceInfo();
              });
          }else if(itemName==="service"){
              this.receiptStatus = item.invoiceStatus;
              this.activeName = item.invoiceStatus;
              this.receiptUrl = item.invoiceUrl;
              this.remark = item.remark;
              this.invoiceUuid = item.invoiceUuid;
              this.payeeUuid = item.payeeUuid;
              this.getInvoiceInfo();
          }
          this.dialogVisible = true;
          this.title = "查看";
      },
      getInvoiceInfo(){
          if(this.invoiceUuid!=null){
              // 查询开票信息
              findInvoiceInfo({uuid:this.invoiceUuid}).then((res)=>{
                  this.invoiceInfo = res;
              });
          }
          if(this.payeeUuid!=null){
              // 查询地址详情
              getAddressDetail({uuid:this.payeeUuid}).then((res)=>{
                  this.addressInfo = res;
              });
          }
      },
  },
};
</script>

<style scoped lang="less">
    .myInvoiceBox {
        padding: 0;
        .orderListTabs {
            position: absolute;
            left: 0;
            top: 0;
            z-index: 999;
            background: #fff;
            width: 100%;
            padding: 20px;
        }
        /deep/ .el-tabs__item {
            padding: 0 25px !important;
            text-align: center;

            &:hover {
                color: #3686d7;
            }

            &:after {
                content: "";
                position: absolute;
                right: 0;
                bottom: 12px;
                width: 1px;
                height: 15px;
                background-color: #e4e7ed;
                z-index: 1;
            }

            &:last-child:after {
                content: "";
                width: 0;
                height: 0;
            }
        }

        /deep/ .el-tabs__active-bar {
            height: 3px;
            background-color: #3686d7;
        }

        /deep/ .el-tabs__item.is-active {
            color: #3686d7;
        }

        /deep/ .el-tabs__nav-wrap::after {
            height: 1px;
        }

        .orderSearchBox {
            display: flex;
            flex-wrap: wrap;

            /deep/ .el-input {
                width: initial;
                margin-bottom: 22px;
                margin-right: 30px;
            }

            /deep/ .el-input__inner {
                width: 242px;
                height: 35px;
                min-height: 35px;
                font-size: 12px;
                color: #999999;
                background-color: #f2f4f7;
                border: 1px solid #f2f4f7;
                border-radius: 5px;

                &:hover,
                &:focus {
                    background-color: #fff;
                    border: 1px solid #108ee9;
                }
            }

            /deep/ .el-input__prefix {
                top: -3px;
            }

            /deep/ .el-input__suffix {
                top: 2px;
            }

            /deep/ .el-button {
                display: block;
                line-height: 35px;
                padding: 0;
                height: 35px;
            }

            .searchBtn {
                width: 82px;
                background: #3d7fff;
                border: none;
                border-radius: 15px;
                font-size: 14px;
                color: #ffffff;
                margin-bottom: 22px;
            }

            .resetBtn {
                color: #333333;
                margin-bottom: 22px;
            }
        }

        .orderListTable {
            .tableHeader {
                display: flex;
                width: 100%;
                height: 35px;
                line-height: 35px;
                background: #f3f7ff;
                border-radius: 5px;
                margin: 0 0 15px;
                li {
                    text-align: center;
                    font-size: 14px;
                    color: rgba(0, 0, 0, 0.85);
                }
            }

            .tableBody {
                li {
                    width: 100%;
                    border: 1px solid #f2f2f2;
                    border-radius: 10px;
                    margin-bottom: 16px;

                    .itemTop {
                        width: 100%;
                        height: 42px;
                        background: #ebf3fb;
                        line-height: 42px;
                        font-size: 14px;
                        color: #333;
                        padding: 0 20px;
                        display: flex;
                        align-items: center;
                        position: relative;
                        .numberCopy {
                            cursor: pointer;
                        }

                        div {
                            margin-right: 30px;
                        }

                        .merchantInfo {
                            display: flex;
                            align-items: center;

                            i {
                                color: #3d7fff;
                                font-size: 25px;
                                cursor: pointer;
                                padding-left: 5px;
                                display: block;
                            }

                            img {
                                display: block;
                                padding-right: 5px;
                            }
                        }

                        .complainBtn {
                            color: #999;
                            position: absolute;
                            right: 20px;
                        }
                    }

                    .itemBottom {
                        display: flex;
                        align-items: center;
                        color: #333;
                        font-size: 13px;

                        .orderInfo {
                            padding: 20px;
                            display: flex;
                            align-items: center;
                            border-bottom: 1px solid #efefef;
                            &:nth-last-child(1) {
                                border-bottom: none;
                            }

                            img {
                                display: block;
                                width: 100px;
                                height: 100px;
                                border-radius: 10px;
                                margin-right: 10px;
                            }
                            .infoContent {
                                width: 140px;
                            }
                        }

                        .invoiceClass {
                            padding: 20px;
                        }

                        .argumentsName {
                            padding-bottom: 8px;
                        }
                        .invoiceCon {
                            h3 {
                                font-size: 14px;
                                font-weight: 700;
                                margin: 0;
                            }

                            .title {
                                font-size: 12px;
                                color: #999999;
                            }
                        }
                        .status {
                            font-size: 14px;
                        }
                        .operationBtn {
                            display: block;
                            color: #0c75d3;
                            text-align: center;
                            width: 100%;
                            margin: 0;
                        }
                        .operationBtnMoney {
                            color: #0c75d3;
                            padding: 6px 20px;
                            border: 1px solid #0c75d3;
                            border-radius: 6px;
                        }
                    }
                }
            }

            .titleImg {
                flex: 1;
            }

            .invoiceTime {
                width: 220px;
                text-align: center;
                div {
                    border-bottom: 1px solid #efefef;
                    &:nth-last-child(1) {
                        border-bottom: none;
                    }
                }
            }
            .price2 {
                line-height: 140px;
            }

            .invoiceMes {
                width: 142px;
                text-align: center;
                div {
                    border-bottom: 1px solid #efefef;
                    &:nth-last-child(1) {
                        border-bottom: none;
                    }
                }
                .numborder {
                    border-right: 1px solid #efefef;
                }
            }
            .num2 {
                line-height: 140px;
            }

            .invoiceClass {
                text-align: center;
                width: 100px;
            }

            .invoiceCon {
                width: 162px;
                text-align: center;
            }

            .status {
                width: 124px;
                text-align: center;
            }

            .operation {
                width: 220px;
                text-align: center;
                display: flex;
                align-items: center;
                justify-content: center;
                .statusName {
                    cursor: pointer;
                    color: #0c75d3;
                    margin-right: 10px;
                }
            }
        }
        .pagination {
            margin-top: 20px;
            text-align: right;
        }
        .invoiceInformation{
            width: 50%;
            padding-left:32px;
        }
        .goodsItem{
            display: flex;
            padding-bottom: 14px;
            font-size: 14px;
            .name{
                color: rgba(0, 0, 0, 0.85);
                min-width: 80px;
            }
            .content{
                color: rgba(0, 0, 0, 0.65);
            }
        }
        .billingInformation{
            .title{
                color: rgba(0, 0, 0, 0.85);
                padding: 5px 0 10px 15px;
                border-bottom: 1px solid #ddd;
                font-weight: 700;
            }
            .billingContent{
                padding: 10px 10px 0;
                color: rgba(0, 0, 0, 0.65);
                .billingItem{
                    display: flex;
                    padding-bottom: 10px;
                }
            }
        }
        .thumbnailClass{
            width: 100%;
            height: 130px;
            margin-right: 30px;
            .avatar{
                width: 130px;
                height: 130px;
                border: 1px dashed #ddd;
                border-radius: 4px;
                line-height: 130px;
                font-size: 24px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/service/modelMyInvoice.vue